import React, { useState, useEffect } from "react";
import { InputGroup } from "../../../../styled-components/input/styles/input";
import IconInputTax from "../../../../styled-components/input/icon-input-tax";
import * as Style from "./styles/inflation-rates";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import { Text } from "../../../../styled-components/text";
import { Button } from "../../../../styled-components/button";
import CarryForward from "../carry-forward/carry-forward";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import TAX_AND_INFLATION_API from "../../../../../apis/tax_and_inflation.api";
import { useHistory } from "react-router-dom";
import {
  TaxSkeletonBox,
  TaxInflationButtonContent,
  TaxInflationInlineLoader,
} from "../tax-inflation-loading";

function InflationRates({
  handleTaxInflationObject,
  preForm,
  data,
  taxInfo,
  parentLoading,
}) {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const isBusy = loading || parentLoading;
  const [inflationRatesData, setInflationRatesData] = useState(null);
  const showSkeleton = isBusy && !inflationRatesData;
  const { styles } = defaultStyles;

  const handleInflationRatesInfo = (obj) => {
    const { name, value } = obj;

    setInflationRatesData({
      ...inflationRatesData,
      [name]: value,
    });
  };
  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        console.log("response==>", data.data);
        const taxInfoData = data.data[0];
        if (taxInfoData) {
          setInflationRatesData({
            "General Inflation Rate":
              taxInfoData && taxInfoData.generalInflationRate
                ? taxInfoData.generalInflationRate
                : "",

            "Medical Inflation Rate":
              taxInfoData && taxInfoData.medicalInflationRate
                ? taxInfoData.medicalInflationRate
                : "",

            "Education Inflation Rate":
              taxInfoData && taxInfoData.educationInflationRate
                ? taxInfoData.educationInflationRate
                : "",

            "Luxury Inflation Rate":
              taxInfoData && taxInfoData.luxuryInflationRate
                ? taxInfoData.luxuryInflationRate
                : "",
            "Housing Infaltion Rate":
              taxInfoData && taxInfoData.housingInflationRate
                ? taxInfoData.housingInflationRate
                : "",
            ...taxInfoData,
          });
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };

  useEffect(() => {
    getTaxInflationDetails();
  }, []);

  const preComponent = {
    name: "carryForward",
    title: "Carry Forward",
    unique: "matric",
    isMulti: false,
    component: CarryForward,
    carryForward: {},
  };

  const fields = [
    {
      Component: IconInputTax,
      value: {
        name: "General Inflation Rate",
        title: "General Inflation Rate",
        icon: "%",
        value: inflationRatesData && inflationRatesData["General Inflation Rate"],
        iconPosition: "end",
        onChange: (event) => handleInflationRatesInfo(event.target),
        tooltip: "Tax_General_Inflation_Rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Medical Inflation Rate",
        title: "Medical Inflation Rate",
        icon: "%",
        value: inflationRatesData && inflationRatesData["Medical Inflation Rate"],
        iconPosition: "end",
        onChange: (event) => handleInflationRatesInfo(event.target),
        tooltip: "Tax_Medical_Inflation_Rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Education Inflation Rate",
        title: "Education Inflation Rate",
        icon: "%",
        value: inflationRatesData && inflationRatesData["Education Inflation Rate"],
        iconPosition: "end",
        onChange: (event) => handleInflationRatesInfo(event.target),
        tooltip: "Tax_Education_Inflation_Rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Luxury Inflation Rate",
        icon: "%",
        title: "Luxury Inflation Rate",
        value: inflationRatesData && inflationRatesData["Luxury Inflation Rate"],
        iconPosition: "end",
        onChange: (event) => handleInflationRatesInfo(event.target),
        tooltip: "Tax_Luxury_Inflation_Rate",
      },
    },
    {
      Component: IconInputTax,
      value: {
        name: "Housing Infaltion Rate",
        title: "Housing Inflation Rate",
        icon: "%",
        value: inflationRatesData && inflationRatesData["Housing Infaltion Rate"],
        iconPosition: "end",
        onChange: (event) => handleInflationRatesInfo(event.target),
        tooltip: "Tax_Housing_Inflation_Rate",
      },
    },
  ];

  const handleSaveTaxInformation = async () => {
    try {
      setLoading(true);

      let payload = {
        generalInflationRate:
          inflationRatesData && +inflationRatesData["General Inflation Rate"],
        medicalInflationRate:
          inflationRatesData && +inflationRatesData["Medical Inflation Rate"],
        educationInflationRate:
          inflationRatesData && +inflationRatesData["Education Inflation Rate"],
        luxuryInflationRate:
          inflationRatesData && +inflationRatesData["Luxury Inflation Rate"],
        housingInflationRate:
          inflationRatesData && +inflationRatesData["Housing Infaltion Rate"],
        // ...inflationRatesData,
      };

      // If id exists, include it to update, else save new
      if (inflationRatesData && inflationRatesData.id) {
        payload.id = inflationRatesData.id;
        let res = await TAX_AND_INFLATION_API.updateTaxInflationDetails(
          payload
        );
        if (res && res.status === 200) {
          history.push("/tax_inflation");
        }
      } else {
        let res = await TAX_AND_INFLATION_API.saveTaxInflationDetails(payload);
        if (res && res.status === 200) {
          history.push("/tax_inflation");
        }
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error while saving/updating tax information:", error);
    }
  };

  const submitData = async () => {
    await handleSaveTaxInformation();
    // handleTaxInflationObject(inflationRatesData);
  };

  if (showSkeleton) {
    return (
      <Style.MainContainer>
        <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
          Inflation Rates
        </h3>
        <Style.FieldsContainer style={{ width: "90%", marginTop: "1rem" }}>
          {Array.from({ length: 5 }).map((_, index) => (
            <InputGroup key={index} style={{ width: "30%", marginTop: "1rem" }}>
              <TaxSkeletonBox width="58%" height={12} style={{ marginBottom: 12 }} />
              <TaxSkeletonBox width="100%" height={38} />
            </InputGroup>
          ))}
        </Style.FieldsContainer>
        <Style.ButtonsContainer>
          <TaxSkeletonBox width={120} height={38} radius={999} />
          <TaxSkeletonBox width={120} height={38} radius={999} />
        </Style.ButtonsContainer>
      </Style.MainContainer>
    );
  }

  return (
    <Style.MainContainer>
      <h3 style={{ color: "#2a3da3", fontWeight: "600", fontSize: "28px" }}>
        Inflation Rates
      </h3>

      <Style.FieldsContainer>
        {fields &&
          fields.map((data, index) => {
            const { value, Component } = data;
            return (
              <InputGroup key={index} style={{ width: "30%" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  <Text style={styles.text.labelText} padding="2rem 0 1rem 0 ">
                    {value.title}
                  </Text>
                  <ToolTipCreator name={value.tooltip} />
                </div>

                <Component key={index} value={value} />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>

      <Style.ButtonsContainer>
        <button
          className="tax-inflation-prev-button"
          disabled={isBusy}
          onClick={() => preForm(preComponent)}
        >
          Previous
        </button>

        <button
          className="tax-inflation-next-button"
          disabled={isBusy}
          onClick={() => submitData()}
        >
          <TaxInflationButtonContent
            isLoading={isBusy}
            idleText="Submit"
            loadingText="Submitting..."
          />
        </button>
      </Style.ButtonsContainer>
      <TaxInflationInlineLoader
        isLoading={isBusy}
        text="Loading inflation rates..."
      />
    </Style.MainContainer>
  );
}

export default InflationRates;
